import React, { useState, useEffect } from "react";


const Feedback = (props) => {

  return (
    <div className="bg-gray-900">
      <h1>This is feedback App</h1>
    </div>

    
  );

};

export default Feedback;
